// extracted by mini-css-extract-plugin
export default {"root":"styles_root__4moHb","text":"styles_text__QHJQW"};